import { draggable } from './draggable'
 
// 统一注册指令
export default {
  install(Vue) {
    Vue.directive('draggable', draggable)
    // 这里可以注册更多的全局指令
  }
} 